// @ts-nocheck
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Dealers/Handlers/LoadDealers";
import { addToChainBefore, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const GreifPopulateApiParameter = createChainHandler("GreifPopulateApiParameter", chain, props => {
    props.apiParameter = {
        ...props.parameter,
        pageSize: 50,
        additionalQueryStringParameters: {
            expand: "properties",
        },
    };
});

addToChainBefore(chain, RequestDataFromApi, GreifPopulateApiParameter);
